module.exports = __webpack_public_path__ + "static/media/fl-ak.a3ca1a75.png";